var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M12,2A10,10,0,1,0,22,12,10.029,10.029,0,0,0,12,2Zm3.7,12.3a.99.99,0,0,1-1.4,1.4L12,13.4,9.7,15.7a.99.99,0,0,1-1.4-1.4L10.6,12,8.3,9.7A.99.99,0,0,1,9.7,8.3L12,10.6l2.3-2.3a.99.99,0,1,1,1.4,1.4L13.4,12Z",
    transform: "translate(-2 -2)",
    fill: "#f80101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b255af7b6f5a6e8f37af2af9cc83b8de.svg";
export { ForwardRef as ReactComponent };